module.exports = __webpack_public_path__ + "static/media/book.730f9cfc.webp";